import React from 'react';
import { Box, Typography, Select, MenuItem, Divider, FormControl, useTheme } from '@mui/material';
import CustomModal from '../../CustomModal';
import palette from '../../../theme/palette';

const BetHistoryDialog = ({ handleClose, handleOpen }) => {
  const theme = useTheme();
  // Static mock data
  const betHistory = [
    { id: 1, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 2, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: -200 },
    { id: 3, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 0 },
    { id: 4, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 5, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 6, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 7, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
    { id: 8, game: 'Lucky 365 - Pinata Wins', category: 'Slots', date: '2025-07-20 14:45', amount: 200 },
  ];

  const getAmountColor = (amount) => {
    if (amount > 0) return '#16A34A';
    if (amount < 0) return '#DC2626';
    return '#6B7280';
  };

  const formatAmount = (amount) => {
    if (amount > 0) return `+${amount.toFixed(2)}`;
    if (amount < 0) return `${amount.toFixed(2)}`;
    return '0.00';
  };

  return (
    <CustomModal hasClose maxWidth="xs" open={handleOpen} onClose={handleClose}>
      <Box sx={{ display: 'flex', flexDirection: 'column', py: 2 }}>
        <Typography variant="h6" fontWeight={600} textAlign="center" mb={2}>
          Bet History
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.5, px: 2, mb: 2 }}>
          <FormControl fullWidth size="small">
            <Select
              defaultValue="all"
              displayEmpty
              sx={{
                backgroundColor: '#F3F4F6',
                borderRadius: '12px',
                fontSize: 14,
                fontWeight: 500,
                height: 40,

                '& fieldset': {
                  border: 'none',
                },
                '& .MuiSelect-select': {
                  padding: '10px 14px',
                },

                // Icon base color
                '& .MuiSelect-icon': {
                  color: '#6B7280', // default icon color (gray-500)
                  transition: 'color 0.3s ease',
                },

                // Icon color when Select is focused (active)
                '&.Mui-focused .MuiSelect-icon': {
                  color: '#000', // your active color
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: 2,
                    mt: 1,
                  },
                },
              }}
            >
              <MenuItem value="all">All Providers</MenuItem>
              <MenuItem value="provider1">Lucky 365</MenuItem>
              <MenuItem value="provider2">Spin Master</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <Select
              defaultValue="3days"
              displayEmpty
              sx={{
                backgroundColor: '#F3F4F6',
                borderRadius: '12px',
                fontSize: 14,
                fontWeight: 500,
                height: 40,
                '& fieldset': {
                  border: 'none',
                },
                '& .MuiSelect-select': {
                  padding: '10px 14px',
                },
                '& .MuiSelect-icon': {
                  color: '#6B7280', // default icon color (gray-500)
                  transition: 'color 0.3s ease',
                },

                '&.Mui-focused .MuiSelect-icon': {
                  color: '#000', // your active color
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: 2,
                    mt: 1,
                  },
                },
              }}
            >
              <MenuItem value="1day">Last 24 Hours</MenuItem>
              <MenuItem value="3days">Last 3 Days</MenuItem>
              <MenuItem value="7days">Last 7 Days</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            maxHeight: 500,
            overflowY: 'auto',
            px: 2,
            scrollbarWidth: 'thin',
            scrollbarColor: '#D1D5DB transparent',

            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#D1D5DB',
              borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#9CA3AF',
            },
          }}
        >
          {betHistory.map((bet, index) => (
            <React.Fragment key={bet.id}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1.5,
                }}
              >
                <Box>
                  <Typography fontSize={14} fontWeight={500}>
                    {bet.game}
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {bet.category} {bet.date}
                  </Typography>
                </Box>

                <Box textAlign="right">
                  <Typography fontSize={14} fontWeight={600} sx={{ color: getAmountColor(bet.amount) }}>
                    {formatAmount(bet.amount)}
                  </Typography>
                  <Typography fontSize={11} color="text.secondary">
                    Bet 200
                  </Typography>
                </Box>
              </Box>

              {index !== betHistory.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </CustomModal>
  );
};

export default BetHistoryDialog;
